import Cookies from 'js-cookie';

const TokenKey = 'isLogged';
const TokenName = 'token';

export function isLogged() {
  return Cookies.get(TokenKey) === '1';
}

export function getToken() {
  return Cookies.get(TokenName) ;
}

export function setToken(token) {
  return Cookies.set(TokenName, token);
}


export function getRoles() {
  return Cookies.get('roles') ;
}
export function setRoles(roles) {
  return Cookies.set('roles', roles);
}

export function setLogged(isLogged) {
  return Cookies.set(TokenKey, isLogged);
}

export function removeToken() {
  console.log('removeToken removeToken');
  Cookies.remove('roles')
  Cookies.remove(TokenName);
  return Cookies.remove(TokenKey);
}
